import { VFC } from 'react'
import { useForm } from 'react-hook-form'
import { MasterDataWithCategory } from 'src/models/MasterData'
import {
  _formalert,
  _menuicon,
  black,
  orange,
  safetyOrange,
  truewhite,
} from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import styled from 'styled-components'

// NOTE: 型がMasterDataWithCategoryであるデータを表示するコンポーネント。表示以外のロジックは親コンポーネントに書く。
export const Selection: VFC<{
  title: string
  description: string
  categories: string[]
  selectedCategory?: string
  setSelectedCategory: (category: string) => void
  items: MasterDataWithCategory[]
  selectedItems: MasterDataWithCategory[]
  setSelectedItems: (selectedItems: MasterDataWithCategory[]) => void
  handleOnSubmit: () => void
  errorMessages: string
}> = ({
  title,
  description,
  categories,
  selectedCategory,
  setSelectedCategory,
  items,
  selectedItems,
  setSelectedItems,
  handleOnSubmit,
  errorMessages,
}) => {
  const { handleSubmit } = useForm()
  // NOTE: カテゴリーの有無で表示方法を変更する
  const filteredItems = items.filter((item) =>
    selectedCategory ? item.category === selectedCategory : item,
  )

  const updateItems = (selected: MasterDataWithCategory, checked: boolean) => {
    checked
      ? setSelectedItems([...selectedItems, selected])
      : setSelectedItems(
          selectedItems.filter((each) => each.value !== selected.value),
        )
  }

  const getBorderRadiusCss = (index: number, length: number) => {
    if (index === 0) return '16px 0 0 0 ;'
    else if (index + 1 === length) return '0 0 0 16px;'
    else return ''
  }

  const selectAll = () => {
    const array = [...selectedItems, ...filteredItems]
    // NOTE: 重複削除
    const filteredArray = array.filter(
      (arrayItem, index, self) =>
        self.findIndex((selfItem) => selfItem.label === arrayItem.label) ===
        index,
    )
    setSelectedItems(filteredArray)
  }

  const deselectAll = () => {
    // NOTE: selectedItemsからfilteredItemsを削除
    const array = selectedItems.filter(
      (item) => !filteredItems.map((item) => item.label).includes(item.label),
    )
    setSelectedItems(array)
  }

  return (
    <Layout>
      <TitleDiv>
        <h1>{`${title}登録`}</h1>
        <p>{description}</p>
      </TitleDiv>
      <SelectionDiv>
        <FlexDiv>
          <FieldTypeDiv>
            {categories.map((category, index, array) => (
              <FieldTypeButton
                key={index}
                type={'button'}
                onClick={() => setSelectedCategory(category)}
                selected={category === selectedCategory}
                borderRadius={getBorderRadiusCss(index, array.length)}
                height={100 / array.length}
              >
                {categories[index]}
              </FieldTypeButton>
            ))}
          </FieldTypeDiv>
          <SpecialtyDiv withCategory={!!categories.length}>
            <h1>{selectedCategory || title}を選択</h1>
            <Control>
              <SelectAllButton type="button" onClick={selectAll}>
                すべて選択
              </SelectAllButton>
              |
              <DeselectAllButton type="button" onClick={deselectAll}>
                解除
              </DeselectAllButton>
            </Control>
            <ButtonsDiv>
              {filteredItems?.map((item) => {
                const checked = selectedItems
                  .map((item) => item.value)
                  .some((value) => item.value == value)

                return (
                  <span key={`${item.value}_${item.label}`}>
                    <input
                      id={item.value}
                      type="checkbox"
                      onChange={({ target: { checked } }) =>
                        updateItems(item, checked)
                      }
                      checked={checked}
                    />
                    <label
                      htmlFor={item.value}
                      style={{
                        background: checked ? orange : truewhite,
                        color: checked ? truewhite : black,
                        border: checked
                          ? `1px solid ${safetyOrange}`
                          : `1px solid ${_menuicon}`,
                      }}
                    >
                      {item.label}
                    </label>
                  </span>
                )
              })}
            </ButtonsDiv>
          </SpecialtyDiv>
        </FlexDiv>
      </SelectionDiv>
      <SaveButtonDiv>
        <SaveButton
          type={'button'}
          onClick={handleSubmit(handleOnSubmit)}
          disabled={!!errorMessages}
        >
          保存する
        </SaveButton>
        <ErrorMessages>
          <p>{errorMessages}</p>
        </ErrorMessages>
      </SaveButtonDiv>
    </Layout>
  )
}

const Layout = styled.div`
  border-radius: 16px;
  width: 928px;
  max-width: min(80vw, 928px);

  text-align: center;
  white-space: pre-wrap;
  line-height: 1.4;

  @media screen and (max-width: 960px) {
    max-width: min(90vw, 700px);
  }
`

const TitleDiv = styled.div`
  display: flex;
  margin: 30px auto;
  padding: 22.5px 40px;
  border-radius: 16px;
  background-color: ${truewhite};
  text-align: left;

  h1 {
    font-size: 24px;
    font-weight: ${fontWeightBold};
    line-height: 20px;
    white-space: nowrap;
  }

  p {
    font-size: 13px;
    line-height: 20px;
    padding-left: 40px;
    white-space: pre-wrap;
  }

  @media screen and (max-width: 960px) {
    padding: 15px 20px;
    margin-bottom: 20px;

    h1 {
      font-size: 20px;
      line-height: 20px;
    }

    p {
      padding-left: 20px;
    }
  }

  @media screen and (max-width: 520px) {
    display: block;
    padding: 10px 15px;
    margin-bottom: 20px;

    h1 {
      font-size: 16px;
      line-height: 16px;
    }

    p {
      font-size: 12px;
      margin-top: 5px;
      padding-left: 0px;
    }
  }
`

const SaveButtonDiv = styled.div`
  display: flex;
  margin: 30px auto;
  padding: 20px 40px;
  line-height: 1.4;
  border-radius: 16px;
  background-color: ${truewhite};
  white-space: pre-wrap;
  text-align: left;

  @media screen and (max-width: 960px) {
    padding: 15px 20px;
    margin-top: 20px;
    font-size: 12px;
  }

  @media screen and (max-width: 520px) {
    padding: 10px 15px;
  }
`

const SelectionDiv = styled.div`
  background-color: ${truewhite};
  border-radius: 16px;
  text-align: center;
  white-space: pre-wrap;
  line-height: 1.4;
`

const FlexDiv = styled.div`
  display: flex;
  min-height: 250px;
`

const FieldTypeDiv = styled.div`
  max-width: 200px;
`

const FieldTypeButton = styled.button<{
  selected: boolean
  borderRadius: string
  height: number
}>`
  display: block;
  width: 100%;
  height: ${(props) => `${props.height}%`};
  margin: 0 auto;
  padding: 15px 20px;
  font-weight: ${fontWeightBold};
  background-color: ${(props) => (props.selected ? `${orange}` : 'white')};
  color: ${(props) => (props.selected ? 'white' : 'black')};
  border-radius: ${(props) => props.borderRadius};
  border: 1px solid ${_menuicon};
  box-shadow: 1px 1px 5px 0.2px #999;
  white-space: nowrap;

  @media screen and (max-width: 960px) {
    font-size: 12px;
    padding: 10px;
  }

  @media screen and (max-width: 520px) {
    font-size: 10px;
    padding: 8px;
  }
`

const SpecialtyDiv = styled.div<{ withCategory: boolean }>`
  max-width: ${(props) => (props.withCategory ? '728px' : '928px')};
  padding: 16px 24px;
  text-align: left;

  h1 {
    font-size: 22px;
    color: ${_menuicon};
  }

  @media screen and (max-width: 960px) {
    max-width: ${(props) => (props.withCategory ? '600px' : '800px')};
    padding: 12px 16px;

    h1 {
      font-size: 18px;
    }
  }

  @media screen and (max-width: 520px) {
    padding: 8px 12px;

    h1 {
      font-size: 16px;
    }
  }
`

const Control = styled.div`
  display: flex;
  margin-top: 16px;
  margin-bottom: 24px;
  color: ${_menuicon};

  @media screen and (max-width: 960px) {
    button {
      font-size: 12px;
    }
  }
`

const SelectAllButton = styled.button`
  margin-right: 12px;
  color: ${black};
  font-size: 14px;
  font-weight: ${fontWeightBold};
`

const DeselectAllButton = styled.button`
  margin-left: 12px;
  color: ${safetyOrange};
  font-size: 14px;
  font-weight: ${fontWeightBold};
`

const ButtonsDiv = styled.div`
  margin-top: 20px;

  input {
    display: none;
  }

  label {
    display: inline-block;
    margin-right: 10px;
    margin-bottom: 10px;
    padding-left: 20px;
    padding-right: 20px;
    width: auto;
    font-size: 12px;
    font-weight: ${fontWeightBold};
    text-align: center;
    line-height: 30px;
    cursor: pointer;
    border: 1px solid ${_menuicon};
    border-radius: 15px;
    white-space: nowrap;
  }

  @media screen and (max-width: 960px) {
    label {
      font-size: 10px;
      margin-right: 8px;
      margin-bottom: 8px;
      padding-left: 8px;
      padding-right: 8px;
      line-height: 26px;
    }
  }

  @media screen and (max-width: 520px) {
    label {
      font-size: 8px;
      margin-right: 6px;
      margin-bottom: 6px;
      padding-left: 6px;
      padding-right: 6px;
      line-height: 24px;
    }
  }
`

const SaveButton = styled.button`
  color: ${orange};
  background-color: #ff6c0033;
  padding: 10px 40px;
  border: 1px solid ${orange};
  border-radius: 5px;
`

const ErrorMessages = styled.div`
  color: ${_formalert};
  text-align: center;
  padding: 10px 40px;
`
